import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { SOLUTIONS as DEFAULT_SOLUTIONS, CASE_STUDIES as DEFAULT_CASES, HERO_SLIDES as DEFAULT_SLIDES } from "@/data/site";

const ContentContext = createContext(null);

export const DEFAULT_HOME = {
  eyebrow: "Multi-Cloud Transformation Partner",
  line1: "One partner.",
  line2: "Every cloud.",
  line3: "No guesswork.",
  paragraph:
    "Cloud Beaker helps organizations architect, migrate, modernize and operate across Google Cloud, Microsoft Azure and Alibaba Cloud \u2014 with strategy, engineering and managed services that turn cloud potential into measurable business outcomes.",
  cta1: "Talk to an Architect",
  cta2: "Explore Solutions",
};

export function ContentProvider({ children }) {
  const [overrides, setOverrides] = useState({ homepage: {}, solutions: {}, case_studies: {} });

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setOverrides({
        homepage: data.homepage || {},
        solutions: data.solutions || {},
        case_studies: data.case_studies || {},
      });
    } catch (e) {
      /* keep defaults */
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const homepage = { ...DEFAULT_HOME, ...(overrides.homepage || {}) };
  const solutions = DEFAULT_SOLUTIONS.map((s) => ({ ...s, ...((overrides.solutions || {})[s.slug] || {}) }));
  const caseStudies = DEFAULT_CASES.map((c) => ({ ...c, ...((overrides.case_studies || {})[c.slug] || {}) }));

  // Hero slides: overrides.homepage.slides may hold per-slide text overrides keyed by id.
  const slideOverrides = (overrides.homepage && overrides.homepage.slides) || {};
  const heroSlides = DEFAULT_SLIDES.map((s) => ({ ...s, ...(slideOverrides[s.id] || {}) }));

  return (
    <ContentContext.Provider value={{ homepage, solutions, caseStudies, heroSlides, overrides, refresh: load }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used within ContentProvider");
  return ctx;
}
